import { CalendarToday } from '@mui/icons-material';
import {
  Button,
  Chip,
  Grid,
  IconButton,
  Modal,
  SvgIcon,
  Tab,
  Table,
  TableBody,
  TableRow,
  Tabs,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import moment from 'moment';
import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { BootstrapDialog } from 'src/components/common-modals/BootstrapDialog';
import DeletePopupModal from 'src/components/common-modals/delete-modal';
import InfoModal from 'src/components/common-modals/info-modal';
import { Seo } from 'src/components/seo';
import SucessModal from 'src/components/sucess-modal';
import useCurrentUser from 'src/hooks/use-current-user';
import { useSettings } from 'src/hooks/use-settings';
import { BasicDateCalendar } from 'src/layouts/components/CustomDatePicker';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';
import { permissions } from 'src/paths';
import { resetEditTaskTimeAction } from 'src/redux/actions/editTaskTimeAction';
import { getAllTherapistTaskAction } from 'src/redux/actions/getAllTherapistAction';
import {
  GET_PATIENT_RECORD,
  getEnterprisePayerPlanType,
  getSingleTherapistAction,
} from 'src/redux/actions/patientAction';
import { reassignTherapistTaskAction } from 'src/redux/actions/rearrangeTherapistTaskAction';
import {
  deleteAnnouncementAction,
  getAllAnnouncementsAction,
  resetDeleteAnnouncementAction,
  resetGetAllAnnouncementsAction,
} from 'src/redux/actions/schedularAnnouncementsAction';
import {
  getAllMaintainedTherapistAction,
  maintainTherapistFilterAction,
  resetAllMaintainedTherapistAction,
} from 'src/redux/actions/schedularTherapistFilterAction';
import {
  editTaskTherapistSchedulingAction,
  editTaskTherapistSchedulingResetAction,
  getAllTaskTypeAction,
  resetAddNewTaskTherapist,
} from 'src/redux/actions/taskTypeAction';
import {
  therapistAssignTaskAction,
  therapistAssignTaskResetAction,
} from 'src/redux/actions/therapistAssignTaskAction';
import { therapistAssignUndoAction } from 'src/redux/actions/therapistAssignmentUndoAction';
import { resetTherapistAssignDataAction } from 'src/redux/actions/therapistDialogAssignTaskAction';
import { getAllTherapistDiciplineAction } from 'src/redux/actions/therapistDiciplineAction';
import {
  getAllTherapistListAction,
  getAllTherapistListResetAction,
} from 'src/redux/actions/therapistListAction';
import {
  migrateTherapisPatientAction,
  migrateTherapisPatientResetAction,
  therapistMigrateTaskAction,
  therapistMigrateTaskResetAction,
} from 'src/redux/actions/therapistMigrateTaskAction';
import {
  therapistPatientUnAssignAction,
  therapistPatientUnAssignReset,
} from 'src/redux/actions/therapistPatientUnAssignAction';
import {
  autoMatchingTherapistAction,
  autoMatchingTherapistResetAction,
  disableAutoMatchAction,
  getAllDisciplineTherapist,
} from 'src/redux/actions/therapistsAction';
import {
  deletePatientTask,
  deleteTherapistTaskNoteAction,
  getTherapistSkillList,
  resetCreateTherapistTaskNote,
  resetDeletePatientTask,
  resetDeleteTherapistTaskNote,
} from 'src/redux/actions/therapySchedulingSkillList';
import LoaderIcon from '../../../../../src/components/LoaderImg/loader.gif';
import '../../../../global.css';
import AddTaskForm from '../../AddTaskForm/AddTaskForm-1';
import EditTaskTime from '../../EditTaskTime/editTaskTime';
import GroupTherapistTask from '../../GroupTherapistTask/groupTherapistTask';
import RescheduleTaskModal from '../../reschedule-task-modal';
import ScheduleTaskNote from '../../taskNote/schedule-task-note';
import '../TherapistTaskInfo/widgets/therapistStyles.scss';
import Loader from '../loader';
import { MultiSelect } from '../multi-select';
import { MultiSelectPatientList } from '../multiSelectPatientList';
import { SkillsMultiSelect } from '../skills-multi-select';
import AnnouncementDialog from './announcement-dialog';
import PayerColorLegend from './payer-color-lagend';
import Switcher from './ptif-switch';
import { AnnouncementIcon, transformedTaskTypeArray } from './schedule-icon';
import TherapistInfo from './therapist-infoV3';
import TherapistTaskList from './therapist-task-list';

const { ADD_DAILY_TASK } = permissions;

interface selectedReSchedulingTaskType {
  uuid?: string;
  localDate?: string;
  tasksType?: string;
  numberOfMinutes?: string;
  description?: string;
  discipline?: string;
  patientUuid?: string;
}

const TherapistSchedule = () => {
  const calenderRef = useRef<HTMLDivElement | null>(null);
  const matches = useMediaQuery('(min-width:1653px)');
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data
  );
  const isAutoMatchDisable = useSelector(
    (state: any) => state?.disableAutoMatchReducer?.response?.data
  );

  const lgdown = useMediaQuery((theme: any) => theme.breakpoints.down('1371'));
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [currentTab, setCurrentTab] = useState<string>('PT');
  const [currentSkillSelected, setCurrentSkillSelected] = useState<string>('');
  const [selectedTaskType, setTaskType] = useState('');
  const [selectedSortType, setSortType] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [openGroupDialog, setOpenGroupDialog] = useState(false);
  const [dragged, setDragged] = useState(false);
  const [draggedId, setDraggedId] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [infoTitle, setInfoTitle] = useState('');
  const [popUpMessage, setPopUpMessage] = useState({
    message: '',
    type: '',
  });
  const [openAddTaskForm, setOpenAddTaskForm] = useState(false);
  const [openEditTimeDialog, setOpenEditTimeDialog] = useState(false);
  const [sucessFullRequest, setSuccessFullRequest] = useState(false);
  const [therapyInfo, setTherapyInfo] = useState<any>({
    therapyType: '',
    taskType: '',
    taskId: '',
    numberOfMinutes: 0,
    isAssigned: false,
  });
  const abortControllerRef = useRef<any>();
  const abortControllerPatinetListRef = useRef<any>();
  const [reSchedulingTask, setReSchedulingTask] = useState(false);
  const [reSchedulingTaskDate, setReSchedulingTaskDate] = useState<Date>(new Date());
  const [taskListState, setTasklistState] = useState<any[]>([]);
  const [therapistIdToDrop, setTherapistIdToDrop] = useState('');
  const [patientTaskPageNo, setPatientTaskPageNo] = useState(0);
  const [therapistListPageNo, setTherapistListPageNo] = useState(0);
  const [patientTotalElementsState, setPatientTotalElementsState] = useState(0);
  const [therapistListState, setTherapistListState] = useState<any[]>([]);
  const [showPatientTaskMainLoader, setPatientTaskShowMainLoader] = useState(true);
  const [showTherapistTaskMainLoader, setTherapistTaskMainLoader] = useState(true);
  const [closeGroupDialog, setCloseGroupDialog] = useState(true);
  const [deleteModalInfo, setDeleteModalInfo] = useState<any>({
    open: false,
    message: '',
    saveLabel: '',
    closeLabel: '',
    title: '',
    deleteType: '',
  });
  const [currentPatientTask, setCurrentPatientTask] = useState('');
  const [switchState, setSwitchState] = useState<'Productivity Goal' | 'PTIF'>('Productivity Goal');
  const [isMaintainFilterAvailable, setIsMaintainFilterAvailable] = useState(false);
  const [filterTherapistList, setFilterTherapistList] = useState([]);
  const [isStatsRefresh, setIsStatsRefresh] = useState(false);
  const [meta, setMeta] = useState({});
  const [migratePatientData, setMigratePatientData] = useState<any>();
  const [unAssignPatientData, setUnAssignPatientData] = useState<any>({});
  const [selectedReSchedulingTask, setSelectedReSchedulingTask] =
    useState<selectedReSchedulingTaskType>({});
  const [taskSelectedId, setTaskSelectedId] = useState<any>([]);
  const [successModalTitle, setSuccessModalTitle] = useState({
    title: '',
    message: '',
  });
  const [openCalender, setOpenCalender] = useState(false);
  const [noOfTherapistEditDialogOpen, setNoOfTherapistEditDialogOpen] = useState<boolean[]>([]);
  const [updateDailyTasks, setUpdateDailyTasks] = useState(false);
  const [readDailyTasks, setreadDailyTasks] = useState(false);
  const [isDragTerminated, setIsDragTerminated] = useState(false);
  const [assignTaskPage, setAssignTaskPage] = useState<any>(0);
  const [isTaskNote, setIsTaskNote] = useState(false);
  const [isEditNote, setIsEditNote] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState('');
  const [openAnnounceDialog, setOpenAnnounceDialog] = useState(false);

  const settings = useSettings();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jsDate = moment(selectedDate, 'DD-MM-YYYY').toDate();
  const formattedDate = moment(jsDate).format('MMM D, YYYY');
  const currentDate = moment();
  const [searchData, setSearchData] = useState('');
  const [providerId] = useCurrentUser(['providerId']);
  const therapistList = useSelector((state: any) => state?.getTherapistListReducer?.response?.data);
  const therapistListResponse = useSelector(
    (state: any) => state?.getTherapistListReducer?.localDate
  );
  const isTaskAdded = useSelector((state: any) => state.AddTaskToTherapistReducer);
  const isTimeEdited = useSelector((state: any) => state.editTaskTimeReducer);
  const therapistTabs = useSelector((state: any) => state?.therapistDiciplineReducer.data);

  const resScheduling = useSelector((state: any) => state.therapistSchedulingTaskEditReducer);
  const taskType = useSelector((state: any) => state.getAllTherapistTaskTypeReducer?.data);
  const deleteTaskResponse = useSelector((state: any) => state?.deleteTaskPatientReducer);
  const autoMatchResponse = useSelector((state: any) => state?.autoMatchingThearpistReducer);
  const assignTaskResponse = useSelector((state: any) => state?.therapistAssignTaskReducer);
  const migrateTaskResponse = useSelector((state: any) => state?.therapistMigrateTaskReducer);
  const migratePatientResponse = useSelector((state: any) => state?.migrateTherapistPatientReducer);
  const unassignPatientReponse = useSelector(
    (state: any) => state?.therapistPatientUnAssignReducer
  );
  const assignGroupData = useSelector(
    (state: any) => state?.therapistAssignTaskReducer?.response?.data
  );

  const assignGroupDataLoading = useSelector(
    (state: any) => state?.therapistAssignTaskReducer?.loading
  );

  const taskUnAssignLoading = useSelector(
    (state: any) => state?.therapistAssignUndoReducer?.loading
  );

  const patientCard = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.content
  );

  const patientTotalElements = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.totalElements
  );

  const isLastPatientList = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.response?.data?.last
  );
  const isLoadingTherapistTask = useSelector(
    (state: any) => state?.getAllTherapistTaskReducer?.loading
  );

  const isLoadingTherapistList = useSelector(
    (state: any) => state?.getTherapistListReducer?.loading
  );

  const getTherapistSkillListResponse = useSelector(
    (state: any) => state?.getSkillsListReducer?.response?.data
  );

  const patientDisciplineList = useSelector(
    (state: any) => state?.getAllDisciplineTherapistReducer?.response?.data
  );

  const getAllMaintainedTherapists = useSelector((state: any) => state.getAllMaintainedTherapist);
  const isTaskNoteCreated = useSelector((state: any) => state.createTherapistTaskNoteReducer);
  const isTaskNoteDeleted = useSelector((state: any) => state.deleteTherapistTaskNoteReducer);
  const deleteAnnouncement = useSelector((state: any) => state?.deleteAnnouncementReducer);

  useEffect(() => {
    dispatch(getAllMaintainedTherapistAction(currentTab, providerId));
    dispatch(
      getTherapistSkillList({
        therapistId: providerId,
      })
    );

    dispatch(getEnterprisePayerPlanType());

    dispatch(
      GET_PATIENT_RECORD({
        data: {
          searchString: '',
        },
        params: {
          active: true,
          page: 0,
          pageSize: 20,
        },
      })
    );

    return () => {
      dispatch(resetTherapistAssignDataAction());
      dispatch(getAllTherapistListResetAction());
      dispatch(therapistAssignTaskResetAction());
      dispatch(therapistMigrateTaskResetAction());
      dispatch(migrateTherapisPatientResetAction());
      dispatch(therapistPatientUnAssignReset());
      dispatch(resetAllMaintainedTherapistAction());
      setIsMaintainFilterAvailable(false);
      // setFilterTherapistList([]);
    };
  }, []);

  useEffect(() => {
    if (getAllMaintainedTherapists.fetched) {
      setFilterTherapistList(
        getAllMaintainedTherapists?.data?.length ? getAllMaintainedTherapists?.data : []
      );
      setIsMaintainFilterAvailable(true);
    }
  }, [getAllMaintainedTherapists]);

  useEffect(() => {
    if (assignGroupData && assignGroupData?.label && closeGroupDialog) {
      setOpenGroupDialog(true);
      setCloseGroupDialog(false);
    } else {
      setTaskSelectedId([]);
    }
  }, [assignGroupData]);

  useEffect(() => {
    if (assignTaskResponse?.response === null && !assignTaskResponse?.isTherapistAssignTask) return;
    if (assignTaskResponse?.response !== null && !assignTaskResponse?.isTherapistAssignTask) {
      setPopUpMessage({
        message: assignTaskResponse?.response?.error || assignTaskResponse?.response?.message,
        type: 'ERROR',
      });

      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      return;
    }

    setPopUpMessage({
      message: assignTaskResponse?.response?.message,
      type: '',
    });

    setTimeout(() => {
      setPopUpMessage({
        message: '',
        type: '',
      });
    }, 3000);
  }, [assignTaskResponse]);

  useEffect(() => {
    if (migrateTaskResponse?.response === null && !migrateTaskResponse?.isTherapistTaskMigrated) {
      return;
    }
    if (migrateTaskResponse?.response !== null && !migrateTaskResponse?.isTherapistTaskMigrated) {
      setPopUpMessage({
        message: migrateTaskResponse?.response?.error || migrateTaskResponse?.response?.message,
        type: 'ERROR',
      });

      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      return;
    }
    setPopUpMessage({ message: migrateTaskResponse?.response?.message, type: '' });
    setTimeout(() => {
      setPopUpMessage({
        message: '',
        type: '',
      });
    }, 3000);
  }, [migrateTaskResponse]);

  useEffect(() => {
    if (
      migratePatientResponse?.response === null &&
      !migratePatientResponse?.isPatientTasksMigrated
    ) {
      return;
    }
    if (
      migratePatientResponse?.response !== null &&
      !migratePatientResponse?.isPatientTasksMigrated
    ) {
      setPopUpMessage({
        message:
          migratePatientResponse?.response?.error || migratePatientResponse?.response?.message,
        type: 'ERROR',
      });

      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      return;
    }
    setPopUpMessage({
      message: migratePatientResponse?.response?.message,
      type: '',
    });
    setTimeout(() => {
      setPopUpMessage({
        message: '',
        type: '',
      });
    }, 3000);
  }, [migratePatientResponse]);

  useEffect(() => {
    if (deleteTaskResponse?.response === null && !deleteTaskResponse?.isTaskDelete) return;
    else if (deleteTaskResponse?.response !== null && !deleteTaskResponse?.isTaskDelete) {
      setPopUpMessage({
        message: deleteTaskResponse?.response?.error || deleteTaskResponse?.response?.message,
        type: 'ERROR',
      });
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
        dispatch(resetDeletePatientTask());
      }, 3000);
    } else if (deleteTaskResponse?.response !== null && deleteTaskResponse?.isTaskDelete) {
      setPopUpMessage({
        message: deleteTaskResponse?.response?.message,
        type: '',
      });
      dispatch(
        disableAutoMatchAction({
          providerId,
          discipline: currentTab ? currentTab : '',
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        })
      );
      dispatch(
        getAllTherapistTaskAction({
          pageNo: patientTaskPageNo,
          data: {
            type: selectedTaskType ? selectedTaskType : '',
            active: true,
            discipline: currentTab ? currentTab : '',
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            providerId,
            skill: currentSkillSelected ? currentSkillSelected : '',
            isV2: true,
          },
        })
      );
      dispatch(
        getAllTherapistDiciplineAction({
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          data: {
            isV2: true,
          },
        })
      );
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
        dispatch(resetDeletePatientTask());
      }, 3000);
    }
  }, [deleteTaskResponse]);

  useEffect(() => {
    if (autoMatchResponse?.response === null && !autoMatchResponse?.isTaskAssigned) return;
    else if (autoMatchResponse?.response !== null && !autoMatchResponse?.isTaskAssigned) {
      setPopUpMessage({
        message: autoMatchResponse?.response?.error || autoMatchResponse?.response?.message,
        type: 'ERROR',
      });
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
        dispatch(autoMatchingTherapistResetAction());
      }, 3000);
    } else if (autoMatchResponse?.response !== null && autoMatchResponse?.isTaskAssigned) {
      setPopUpMessage({
        message: autoMatchResponse?.response?.message,
        type: '',
      });
      dispatch(
        disableAutoMatchAction({
          providerId,
          discipline: currentTab ? currentTab : '',
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        })
      );
      dispatch(
        getAllTherapistTaskAction({
          pageNo: patientTaskPageNo,
          data: {
            type: selectedTaskType ? selectedTaskType : '',
            active: true,
            discipline: currentTab ? currentTab : '',
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            providerId,
            skill: currentSkillSelected ? currentSkillSelected : '',
            isV2: true,
          },
        })
      );
      dispatch(
        getAllTherapistListAction({
          pageNo: therapistListPageNo,
          data: {
            providerId,
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            discipline: currentTab ? currentTab : '',
            sortBy: selectedSortType ? selectedSortType : '',
            signal: abortControllerRef.current.signal,
            searchData,
            filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
            isV2: true,
          },
        })
      );
      dispatch(
        getAllTherapistDiciplineAction({
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          data: {
            isV2: true,
          },
        })
      );
      setIsStatsRefresh(true);
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
        dispatch(autoMatchingTherapistResetAction());
      }, 3000);
    }
  }, [autoMatchResponse]);

  useEffect(() => {
    if (unassignPatientReponse?.response === null && !unassignPatientReponse?.isSuccess) {
      return;
    }
    if (unassignPatientReponse?.response !== null && !unassignPatientReponse?.isSuccess) {
      setPopUpMessage({
        message:
          unassignPatientReponse?.response?.error || unassignPatientReponse?.response?.message,
        type: 'ERROR',
      });

      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      return;
    }
    setPopUpMessage({
      message: unassignPatientReponse?.response?.message,
      type: '',
    });
    setTimeout(() => {
      setPopUpMessage({
        message: '',
        type: '',
      });
    }, 3000);
  }, [unassignPatientReponse]);

  useEffect(() => {
    setNoOfTherapistEditDialogOpen([]);
    therapistListState?.forEach((e) => {
      setNoOfTherapistEditDialogOpen((prev: any[]) => [...prev, false]);
    });
  }, [therapistListState]);

  useEffect(() => {
    dispatch(getSingleTherapistAction({ discipline: currentTab }));
  }, [currentTab]);

  useEffect(() => {
    if (patientTaskPageNo === 0) {
      setTasklistState(patientCard);
    } else {
      setTasklistState((prev: any) => {
        const mergedArray = [...prev, ...(patientCard || [])];
        const uniqueMap = new Map(mergedArray?.map((item) => [item.uuid, item]));
        const uniqueArray = Array.from(uniqueMap?.values());
        return uniqueArray;
      });
    }
    setPatientTaskShowMainLoader(true);
    return;
  }, [patientCard]);

  useEffect(() => {
    if (
      therapistListPageNo === 0 &&
      moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') === therapistListResponse
    ) {
      setTherapistListState(therapistList?.content);
    } else if (moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') === therapistListResponse) {
      setTherapistListState((prev: any) => {
        const mergedArray = [...prev, ...(therapistList?.content || [])];
        const uniqueMap = new Map(mergedArray.map((item) => [item.uuid, item]));
        const uniqueArray = Array.from(uniqueMap?.values());
        return uniqueArray;
      });
    }
    setTherapistTaskMainLoader(true);
  }, [therapistList]);

  useEffect(() => {
    if (taskListState && therapistListState && taskListState.length > patientTotalElementsState) {
      const uuidsInA = new Set(
        therapistListState
          .flatMap((item: any) => item.assignedTaskList?.map((task: any) => task.taskUuids))
          .flat()
      );
      const filteredB = taskListState.filter((item) => !uuidsInA.has(item.uuid));
      setTasklistState(filteredB);
    }
  }, [taskListState, therapistListState]);

  useEffect(() => {
    setShowLoader(
      assignGroupDataLoading ||
        autoMatchResponse?.loading ||
        taskUnAssignLoading ||
        unassignPatientReponse?.loading
    );
  }, [assignGroupDataLoading, autoMatchResponse, taskUnAssignLoading, unassignPatientReponse]);

  useEffect(() => {
    setPatientTotalElementsState(patientTotalElements);
  }, [patientTotalElements]);

  useEffect(() => {
    if (selectedDate) {
      abortControllerPatinetListRef.current = new AbortController();
      dispatch(
        disableAutoMatchAction({
          providerId,
          discipline: currentTab ? currentTab : '',
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        })
      );
      dispatch(
        getAllTherapistTaskAction({
          pageNo: patientTaskPageNo,
          data: {
            type: selectedTaskType ? selectedTaskType : '',
            active: true,
            discipline: currentTab ? currentTab : '',
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            signal: abortControllerPatinetListRef?.current?.signal,
            providerId,
            skill: currentSkillSelected ? currentSkillSelected : '',
            isV2: true,
          },
        })
      );

      dispatch(
        getAllTherapistDiciplineAction({
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          data: {
            isV2: true,
          },
        })
      );
    } else {
      handleChangeDate(new Date());
    }
  }, [
    selectedTaskType,
    currentTab,
    selectedDate,
    providerId,
    dispatch,
    patientTaskPageNo,
    currentSkillSelected,
  ]);

  useEffect(() => {
    setMeta({
      providerId,
      type: selectedTaskType ? selectedTaskType : '',
      active: true,
      discipline: currentTab ? currentTab : '',
      date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
      skill: currentSkillSelected ? currentSkillSelected : '',
      sortBy: selectedSortType ? selectedSortType : '',
      taskPage: 0,
      filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
      therapistPage: therapistListPageNo,
    });
  }, [
    selectedTaskType,
    currentTab,
    selectedDate,
    filterTherapistList,
    providerId,
    therapistListPageNo,
    currentSkillSelected,
    selectedSortType,
  ]);

  useEffect(() => {
    if (selectedDate && isMaintainFilterAvailable) {
      abortControllerRef.current = new AbortController();

      dispatch(
        getAllTherapistListAction({
          pageNo: therapistListPageNo,
          data: {
            providerId,
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            discipline: currentTab ? currentTab : '',
            sortBy: selectedSortType ? selectedSortType : '',
            signal: abortControllerRef.current.signal,
            searchData,
            filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
            isV2: true,
          },
        })
      );
    }
  }, [
    selectedDate,
    filterTherapistList,
    selectedSortType,
    providerId,
    dispatch,
    searchData,
    therapistListPageNo,
    currentTab,
    isMaintainFilterAvailable,
  ]);

  useEffect(() => {
    if (selectedDate) {
      dispatch(
        getAllDisciplineTherapist({
          pageNo: 0,
          data: {
            providerId,
            localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            discipline: currentTab ? currentTab : '',
            sortBy: selectedSortType ? selectedSortType : '',
            searchData: '',
            forFilter: true,
          },
        })
      );
    }
  }, [selectedDate, providerId, dispatch, currentTab]);

  useEffect(() => {
    dispatch(
      getAllTaskTypeAction({
        providerId,
        active: true,
      })
    );
  }, [providerId, dispatch, selectedDate]);

  useEffect(() => {
    if (permissionData?.currentPermissions.length > 0) {
      if (permissionData?.currentPermissions.includes('Read Daily Task')) {
        setreadDailyTasks(true);
      }
      if (permissionData?.currentPermissions.includes('Update Daily Task')) {
        setUpdateDailyTasks(true);
      }
    }
  }, [permissionData]);

  useEffect(() => {
    if (isLoadingTherapistTask || isLoadingTherapistList) {
      if (!isDragTerminated) {
        document.dispatchEvent(new MouseEvent('mouseup'));
        setIsDragTerminated(true);
      }
    }
  }, [isLoadingTherapistList, isLoadingTherapistTask, isDragTerminated]);

  useEffect(() => {
    if (!resScheduling?.isEditedTask && resScheduling?.response === null) return;

    if (!resScheduling?.isEditedTask && resScheduling?.response !== null) {
      setReSchedulingTask(false);
      dispatch(editTaskTherapistSchedulingResetAction());
      return;
    }
    setSuccessModalTitle((prev) => ({
      ...prev,
      title: 'Task reschedule  Successfully!',
      message: '',
    }));
    setReSchedulingTask(false);
    setSuccessFullRequest(true);
    dispatch(editTaskTherapistSchedulingResetAction());
  }, [resScheduling]);

  useEffect(() => {
    if (openCalender) {
      const handleClickOutside = (event: any) => {
        if (calenderRef.current && !calenderRef.current.contains(event.target)) {
          handleClickCalender();
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [openCalender]);

  useEffect(() => {
    if (!isTaskAdded.isTaskAdded && isTaskAdded?.response === null) return;

    if (!isTaskAdded.isTaskAdded && isTaskAdded?.response !== null) {
      dispatch(resetAddNewTaskTherapist());
      return;
    }
    setOpenAddTaskForm(false);
    //new code
    setPatientTaskShowMainLoader(true);
    setPatientTaskPageNo(0);
    setTherapistListPageNo(0);
    setSuccessModalTitle((prev) => ({
      ...prev,
      title: 'Task added successfully!',
      message: 'Current task is added to the task list for the day.',
    }));
    setSuccessFullRequest(true);
    dispatch(resetAddNewTaskTherapist());
  }, [isTaskAdded]);

  useEffect(() => {
    if (!isTimeEdited.isTimeEdited && isTimeEdited?.response === null) return;

    if (isTimeEdited.isTimeEdited && isTimeEdited?.response !== null) {
      handleEditTime(isTimeEdited?.isAssigned);
      setOpenEditTimeDialog(false);
      setNoOfTherapistEditDialogOpen([]);
      therapistListState?.forEach((e) => {
        setNoOfTherapistEditDialogOpen((prev: any[]) => [...prev, false]);
      });

      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Time edited successfully!',
        message: `Time has been successfully updated`,
      }));
      setSuccessFullRequest(true);
    }
  }, [isTimeEdited]);

  useEffect(() => {
    if (!isTaskNoteCreated.isTaskCreated && isTaskNoteCreated?.response === null) return;
    if (!isTaskNoteCreated.isTaskCreated && isTaskNoteCreated?.response !== null) {
      dispatch(resetCreateTherapistTaskNote());
      setIsTaskNote(false);
      return;
    }

    if (isTaskNoteCreated.isTaskCreated && isTaskNoteCreated?.response !== null) {
      getTherapistAndTask();
      setIsTaskNote(false);
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Note added successfully',
        message: `The note will appear on the therapist's Dashboard`,
      }));
      setSuccessFullRequest(true);
      dispatch(resetCreateTherapistTaskNote());
    }
  }, [isTaskNoteCreated]);

  useEffect(() => {
    if (!isTaskNoteDeleted.isDeletedTaskNote && isTaskNoteDeleted?.response === null) return;
    if (!isTaskNoteDeleted.isDeletedTaskNote && isTaskNoteDeleted?.response !== null) {
      dispatch(resetDeleteTherapistTaskNote());
      return;
    }

    if (isTaskNoteDeleted.isDeletedTaskNote && isTaskNoteDeleted?.response !== null) {
      getTherapistAndTask();
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Note Deleted successfully',
        message: '',
      }));
      setSuccessFullRequest(true);
      dispatch(resetDeleteTherapistTaskNote());
    }
  }, [isTaskNoteDeleted]);

  useEffect(() => {
    if (!deleteAnnouncement?.response) return;
    if (deleteAnnouncement?.response !== null && deleteAnnouncement?.response?.code !== 'OK') {
      setPopUpMessage({ message: deleteAnnouncement?.response?.message, type: 'ERROR' });
      setTimeout(() => {
        setPopUpMessage({
          message: '',
          type: '',
        });
      }, 3000);
      dispatch(resetDeleteAnnouncementAction());
      return;
    }
    setPopUpMessage({ message: deleteAnnouncement?.response?.message, type: '' });
    setTimeout(() => {
      setPopUpMessage({ message: '', type: '' });
    }, 3000);
    dispatch(resetDeleteAnnouncementAction());
  }, [deleteAnnouncement]);

  const handleTabsChange = useCallback(
    (event: ChangeEvent<any>, value: string): void => {
      setIsMaintainFilterAvailable(false);
      dispatch(resetAllMaintainedTherapistAction());
      setFilterTherapistList([]);
      abortControllerRef.current.abort();
      abortControllerPatinetListRef.current.abort();
      dispatch(getAllMaintainedTherapistAction(value, providerId));
      setCurrentTab(value);
      setPatientTaskShowMainLoader(true);
      setPatientTaskPageNo(0);
      setTherapistListPageNo(0);
      setTherapistListState([]);
      setTaskSelectedId([]);
    },
    [getAllMaintainedTherapists]
  );

  const rearrangeTask = (taskList: any) => {
    const convertedResponse = taskList?.map(function (item: any, index: number) {
      return {
        taskSchedulingId: item.uuid,
        priority: taskList.length - index,
      };
    });
    dispatch(
      reassignTherapistTaskAction({
        providerId,
        dicipline: currentTab,
        data: convertedResponse,
      })
    );
  };

  function getTherapistPageNumber(therapistList: any, therapistUuid: string): number {
    const therapistsPerPage = 20;

    const index = therapistList?.findIndex((therapist: any) => therapist?.uuid === therapistUuid);
    if (index === -1) return -1;
    return Math.floor(index / therapistsPerPage);
  }

  const taskSummary = (therapistId: string, patientId: string) => {
    const sourceTherapist = therapistListState?.find((item: any) => item?.uuid === therapistId);
    const patient = sourceTherapist?.assignedPatients[patientId];
    return {
      isTherapyTaskAssigned:
        patient?.TaskType.includes('GROUP_THERAPY') || patient?.TaskType.includes('CONCURRENT'),
      isNonTherapyAssigned:
        patient?.TaskType.includes('THERAPY') ||
        patient?.TaskType.includes('EVALUATION') ||
        patient?.TaskType.includes('INSURANCE_CALL') ||
        patient?.TaskType.includes('SCREENINGS'),
    };
  };

  const dragUnassign = (taskId: string, therapistId: string) => {
    dispatch(
      therapistAssignUndoAction({
        providerId,
        type: selectedTaskType ? selectedTaskType : '',
        active: true,
        searchData,
        currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',

        filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
        meta: {
          providerId,
          type: selectedTaskType ? selectedTaskType : '',
          active: true,
          discipline: currentTab ? currentTab : '',
          date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          skill: currentSkillSelected ? currentSkillSelected : '',
          sortBy: selectedSortType ? selectedSortType : '',
          taskPage: 0,
          therapistPage: 0,
        },
        discipline: currentTab ? currentTab : '',
        date: selectedDate,
        skill: currentSkillSelected ? currentSkillSelected : '',
        sortBy: selectedSortType ? selectedSortType : '',
        therapistId: therapistId ? therapistId : '',
        taskType: 'task-uuid',
        taskId: taskId ? taskId : '',
        requestBody: {
          taskUuids: [taskId],
          groupUuid: null,
        },
        isV2: true,
      })
    );
  };

  const patientUnAssign = (patientId: string, therapistId: string) => {
    dispatch(
      therapistPatientUnAssignAction({
        providerId,
        therapistId: therapistId ? therapistId : '',
        currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        patientId: patientId ? patientId : '',
        type: selectedTaskType ? selectedTaskType : '',
        active: true,
        searchData,
        filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
        discipline: currentTab ? currentTab : '',
        date: selectedDate,
        skill: currentSkillSelected ? currentSkillSelected : '',
        sortBy: selectedSortType ? selectedSortType : '',
        meta: {
          providerId,
          type: selectedTaskType ? selectedTaskType : '',
          active: true,
          discipline: currentTab ? currentTab : '',
          date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          skill: currentSkillSelected ? currentSkillSelected : '',
          sortBy: selectedSortType ? selectedSortType : '',
          taskPage: 0,
          therapistPage: 0,
        },
        isV2: true,
      })
    );
  };

  const handleDragDrop = (result: any) => {
    if (isDragTerminated) {
      setIsDragTerminated(false);
      return;
    }
    if (!updateDailyTasks || !readDailyTasks) return;
    setDragged(false);
    setDraggedId('');
    const { source, destination, draggableId } = result;
    if (!destination) return;
    if (source.droppableId === destination.droppableId && source.index === destination.index)
      return;

    if (destination.droppableId === 'ROOT' && draggableId.includes('~')) {
      const patientId = draggableId.split('~')[0];
      const sourceTherapistId = source.droppableId;

      let assignedStatus = taskSummary(sourceTherapistId, patientId);
      if (assignedStatus.isTherapyTaskAssigned && assignedStatus.isNonTherapyAssigned) {
        setInfoTitle('Unassign Individual Tasks Only');
        setUnAssignPatientData({ patientId: patientId, therapistId: sourceTherapistId });
        setOpenDialog(true);
      } else if (assignedStatus.isTherapyTaskAssigned && !assignedStatus.isNonTherapyAssigned) {
        setInfoTitle('Unassigning Group & Concurrent Tasks');
        setOpenDialog(true);
      } else {
        patientUnAssign(patientId, sourceTherapistId);
      }
      return;
    }

    if (destination.droppableId === 'ROOT' && draggableId.includes('+')) {
      const taskId = draggableId.split('+')[0];
      const sourceTherapistId = source.droppableId;
      dragUnassign(taskId, sourceTherapistId);
      return;
    }

    if (destination.droppableId === 'ROOT') {
      const sourceIndex = source.index;
      const destinationIndex = destination.index;
      setTasklistState((prevState) => {
        const reorderedStore = [...prevState];
        const [removedStore] = reorderedStore.splice(sourceIndex, 1);
        reorderedStore.splice(destinationIndex, 0, removedStore);
        rearrangeTask(reorderedStore);
        return reorderedStore;
      });
      return;
    }
    setPatientTaskPageNo(0);

    if (draggableId.includes('+') && source.droppableId !== destination.droppableId) {
      const taskId = draggableId.split('+')[0];
      const sourceTherapistId = source.droppableId;
      const destinationTherapistId = destination.droppableId;

      const selectedTaskForDrop = sourceTherapistId;
      setTherapistIdToDrop(destination.droppableId);
      const allTherapistListData = [...therapistListState];
      const sourcePage = getTherapistPageNumber(allTherapistListData, selectedTaskForDrop);
      const destinationPage = getTherapistPageNumber(allTherapistListData, destination.droppableId);
      dispatch(
        therapistMigrateTaskAction({
          providerId,
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          sourceTherapist: sourceTherapistId,
          targetTherapist: destinationTherapistId,
          filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
          taskId: taskId,
          singleAssign: true,
          meta: meta,
          sourcePage: sourcePage,
          destinationPage: destinationPage,
          isV2: true,
        })
      );
      return;
    }

    if (draggableId.includes('~') && source.droppableId !== destination.droppableId) {
      const patientId = draggableId.split('~')[0];
      const sourceTherapistId = source.droppableId;
      const destinationTherapistId = destination.droppableId;

      const selectedTaskForDrop = sourceTherapistId;
      setTherapistIdToDrop(destination.droppableId);
      const allTherapistListData = [...therapistListState];
      const sourcePage = getTherapistPageNumber(allTherapistListData, selectedTaskForDrop);
      const destinationPage = getTherapistPageNumber(allTherapistListData, destination.droppableId);

      let assignedStatus = taskSummary(sourceTherapistId, patientId);
      if (assignedStatus.isTherapyTaskAssigned && assignedStatus.isNonTherapyAssigned) {
        setMigratePatientData({
          providerId,
          patientId: patientId,
          assignDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          sourceTherapist: sourceTherapistId,
          targetTherapist: destinationTherapistId,
          filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
          singleAssign: true,
          meta: meta,
          sourcePage: sourcePage,
          destinationPage: destinationPage,
          isV2: true,
        });
        setInfoTitle('Reassign Individual Tasks Only');
        setOpenModal(true);
      } else if (assignedStatus.isTherapyTaskAssigned && !assignedStatus.isNonTherapyAssigned) {
        setInfoTitle('Reassigning Group & Concurrent Tasks');
        setOpenModal(true);
      } else {
        dispatch(
          migrateTherapisPatientAction({
            providerId,
            patientId: patientId,
            assignDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            sourceTherapist: sourceTherapistId,
            targetTherapist: destinationTherapistId,
            filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
            singleAssign: true,
            meta: meta,
            sourcePage: sourcePage,
            destinationPage: destinationPage,
            isV2: true,
          })
        );
      }
      return;
    }

    const addToTaskId = destination.droppableId;
    const selectedTaskForDrop = result.draggableId;
    const destinationAssignPage = getTherapistPageNumber(
      therapistListState,
      destination.droppableId
    );
    if (source.droppableId === destination.droppableId) {
      return;
    }
    setTherapistIdToDrop(addToTaskId);
    setAssignTaskPage(destinationAssignPage);
    dispatch(
      therapistAssignTaskAction({
        providerId,
        therapistId: addToTaskId,
        searchData: searchData,
        date: selectedDate,
        currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
        refresh: false,
        meta: meta,
        destinationAssignPage: destinationAssignPage,
        data: {
          wantToGroup: false,
          unprocessedData: taskSelectedId.length > 0 ? taskSelectedId : [selectedTaskForDrop],
          processedData: [],
          groupUuid: null,
        },
        isV2: true,
        toPick:true
      })
    );
  };

  const handleOpenAddTaskForm = () => {
    setOpenAddTaskForm(true);
  };

  const handleCloseAddTaskForm = () => {
    setOpenAddTaskForm(false);
  };

  const handleEditTimeDialog = () => {
    setOpenEditTimeDialog((prev) => !prev);
  };

  function isString(value: any) {
    return typeof value === 'string';
  }

  const DeleteTherapistPatient = (therapistId: string, taskSchedulingData: any) => {
    setPatientTaskPageNo(0);
    setTherapistListPageNo(0);

    setMeta({
      providerId,
      type: selectedTaskType ? selectedTaskType : '',
      active: true,
      discipline: currentTab ? currentTab : '',
      date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
      skill: currentSkillSelected ? currentSkillSelected : '',
      sortBy: selectedSortType ? selectedSortType : '',
      taskPage: 0,
      therapistPage: 0,
      filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
    });
    dispatch(
      therapistAssignUndoAction({
        providerId,
        type: selectedTaskType ? selectedTaskType : '',
        active: true,
        searchData,
        currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',

        filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
        meta: {
          providerId,
          type: selectedTaskType ? selectedTaskType : '',
          active: true,
          discipline: currentTab ? currentTab : '',
          date: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          skill: currentSkillSelected ? currentSkillSelected : '',
          sortBy: selectedSortType ? selectedSortType : '',
          taskPage: 0,
          therapistPage: 0,
        },
        discipline: currentTab ? currentTab : '',
        date: selectedDate,
        skill: currentSkillSelected ? currentSkillSelected : '',
        sortBy: selectedSortType ? selectedSortType : '',
        therapistId: therapistId ? therapistId : '',
        taskType: taskSchedulingData.groupUuid ? 'group-uuid' : 'task-uuid',
        taskId: taskSchedulingData.groupUuid
          ? taskSchedulingData.groupUuid
          : taskSchedulingData.taskUuids,
        requestBody: {
          taskUuids: !taskSchedulingData.groupUuid
            ? isString(taskSchedulingData.taskUuids)
              ? [taskSchedulingData.taskUuids]
              : taskSchedulingData.taskUuids
            : null,
          groupUuid: taskSchedulingData.groupUuid ? taskSchedulingData.groupUuid : null,
        },
        isV2: true,
      })
    );
  };

  const handleCloseInfo = () => {
    setOpenModal(false);
    setMigratePatientData('');
  };

  const handleCloseDialog = () => {
    setUnAssignPatientData({});
    setOpenDialog(false);
  };

  const handleChangeDate = (e: any) => {
    abortControllerRef?.current?.abort();
    abortControllerPatinetListRef?.current?.abort();
    const originalDate = new Date(e);
    const day = originalDate.getDate().toString().padStart(2, '0');
    const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
    const year = originalDate.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    if (formattedDate !== selectedDate) {
      setPatientTaskShowMainLoader(true);
      setTherapistTaskMainLoader(true);
      setTasklistState([]);
      setTherapistListState([]);
      setPatientTaskPageNo(0);
      setTherapistListPageNo(0);
      setSelectedDate(formattedDate);
      setOpenCalender(false);
    } else {
      setOpenCalender(false);
    }
  };

  const closeSuccessModal = () => {
    setSuccessFullRequest(false);
  };

  const handleClickCalender = () => {
    setOpenCalender((prev) => !prev);
  };

  const getRightSideList = () => {
    setTherapistListPageNo(0);
    dispatch(
      getAllTherapistListAction({
        pageNo: 0,
        data: {
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          discipline: currentTab ? currentTab : '',
          sortBy: selectedSortType ? selectedSortType : '',
          searchData,
          filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
          isV2: true,
        },
      })
    );
  };

  const getLeftSideList = () => {
    setTasklistState([]);
    setPatientTaskPageNo(0);

    dispatch(
      disableAutoMatchAction({
        providerId,
        discipline: currentTab ? currentTab : '',
        currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
      })
    );
    dispatch(
      getAllTherapistTaskAction({
        pageNo: 0,
        data: {
          type: selectedTaskType ? selectedTaskType : '',
          active: true,
          discipline: currentTab ? currentTab : '',
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          providerId,
          skill: currentSkillSelected ? currentSkillSelected : '',
          isV2: true,
        },
      })
    );
    dispatch(
      getAllTherapistDiciplineAction({
        providerId,
        localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        data: {
          isV2: true,
        },
      })
    );
  };

  const handleEditTime = (isAssigned?: any) => {
    dispatch(resetEditTaskTimeAction());

    if (typeof isAssigned === 'boolean') {
      // Only do one side depending on the value
      if (isAssigned) {
        getRightSideList();
      } else {
        getLeftSideList();
      }
    } else {
      // If isAssigned is undefined, do everything
      getRightSideList();
      getLeftSideList();
    }
  };

  const getTherapistAndTask = () => {
    dispatch(
      getAllTherapistTaskAction({
        pageNo: patientTaskPageNo,
        data: {
          type: selectedTaskType ? selectedTaskType : '',
          active: true,
          discipline: currentTab ? currentTab : '',
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          providerId,
          skill: currentSkillSelected ? currentSkillSelected : '',
          isV2: true,
        },
      })
    );
    dispatch(
      getAllTherapistListAction({
        pageNo: therapistListPageNo,
        data: {
          providerId,
          localDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
          discipline: currentTab ? currentTab : '',
          sortBy: selectedSortType ? selectedSortType : '',
          signal: abortControllerRef.current.signal,
          searchData,
          filterByUuid: filterTherapistList?.length > 0 ? filterTherapistList : null,
          isV2: true,
        },
      })
    );
  };

  const handleToRescheduleTask = (task: any) => {
    setSelectedPatient(task?.patientLastname + ' ' + task?.patientFirstname);
    setReSchedulingTaskDate(new Date(task?.localDate));

    if (
      task?.tasksType === 'GROUP_THERAPY' ||
      task?.tasksType === 'THERAPY' ||
      task?.tasksType === 'CONCURRENT'
    ) {
      setInfoTitle('Reschedule therapy task');
      setOpenModal(true);
      return;
    } else {
      const jsDate = moment(task?.localDate, 'DD-MM-YYYY').toDate();
      setSelectedReSchedulingTask(task);
      setReSchedulingTask(true);
      return;
    }
  };

  const handleSaveBtn = () => {
    if (migratePatientData) {
      dispatch(migrateTherapisPatientAction(migratePatientData));
      setMigratePatientData('');
      setOpenModal(false);
      return;
    }

    navigate('/scheduling/therapy-planning/details/info', {
      state: {
        patientId: selectedPatient,
        searchData: selectedPatient,
      },
    });
  };

  const handleUnassignConfirm = () => {
    patientUnAssign(unAssignPatientData?.patientId, unAssignPatientData?.therapistId);
    setUnAssignPatientData({});
    setOpenDialog(false);
  };

  const handleSelectDate = (date: any) => {
    const calenderDateSelected = moment(date).format('DD-MM-YYYY');
    const newTaskType = taskType?.find(
      (res: any) => res?.key === selectedReSchedulingTask?.tasksType
    );

    setPatientTaskShowMainLoader(true);
    if (Object.keys(selectedReSchedulingTask)?.length !== 0) {
      dispatch(
        editTaskTherapistSchedulingAction({
          providerId,
          date: selectedDate ? selectedDate : '',
          currentDate: selectedDate ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',

          data: {
            uuid: selectedReSchedulingTask?.uuid,
            selectedTaskType: selectedTaskType,
            localDate: calenderDateSelected,
            tasksType: newTaskType?.key,
            numberOfMinutes: selectedReSchedulingTask?.numberOfMinutes,
            description: selectedReSchedulingTask?.description,
            patientId: selectedReSchedulingTask?.patientUuid,
            discipline: selectedReSchedulingTask?.discipline,
            pageNo: patientTaskPageNo,
            isV2: true,
          },
        })
      );
      // setTasklistState(
      //   taskListState.filter((item: any) => item.uuid !== selectedReSchedulingTask?.uuid)
      // );
    } else {
      setReSchedulingTask(false);
    }
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalInfo((prevState: any) => ({ ...prevState, open: false }));
    setTimeout(() => {
      setDeleteModalInfo({
        message: '',
        saveLabel: '',
        closeLabel: '',
        title: '',
        deleteType: '',
        uuid: '',
      });
    }, 100);
  };

  const setOpenTaskDeleteModal = () => {
    setDeleteModalInfo({
      open: true,
      message: 'Are you sure you want to delete this task?',
      saveLabel: 'Delete Task',
      closeLabel: 'Cancel',
      title: 'Delete Task',
      deleteType: 'DELETE_TASK',
    });
  };

  const handleOpenDeleteAnnounceModal = (announceUuid: string) => {
    setOpenAnnounceDialog(false);
    setDeleteModalInfo({
      open: true,
      message: 'Are you sure you want to delete this announcement?',
      saveLabel: 'Delete announcement',
      closeLabel: 'Cancel',
      title: 'Delete Announcement',
      deleteType: 'DELETE_ANNOUNCEMENT',
      uuid: announceUuid,
    });
  };

  const handleOpenDeleteTaskNote = () => {
    setIsTaskNote(false);
    setDeleteModalInfo({
      open: true,
      message: 'Are you sure you want to delete this note?',
      saveLabel: 'Delete note',
      closeLabel: 'Cancel',
      title: 'Delete note',
      deleteType: 'DELETE_NOTE',
    });
  };

  const handleDeleteBtn = () => {
    if (deleteModalInfo.deleteType === 'DELETE_TASK') {
      dispatch(
        deletePatientTask({
          providerId,
          taskId: currentPatientTask,
        })
      );
    } else if (deleteModalInfo.deleteType === 'DELETE_NOTE') {
      dispatch(
        deleteTherapistTaskNoteAction({
          providerId: providerId,
          taskId: currentPatientTask,
        })
      );
    } else if (deleteModalInfo.deleteType === 'DELETE_ANNOUNCEMENT') {
      dispatch(
        deleteAnnouncementAction({
          uuid: deleteModalInfo?.uuid,
        })
      );
    }
    handleCloseDeleteModal();
  };

  const handleCloseTaskNote = useCallback(() => {
    setIsTaskNote(false);
  }, []);

  const handleOpenTaskNote = useCallback(() => {
    setIsTaskNote(true);
  }, []);

  const handleScroll = useCallback(
    (event: any) => {
      const scrollThreshold = 0.8;

      if (
        Math.abs(
          (event.target as any).scrollHeight -
            (event.target as any).scrollTop -
            (event.target as any).clientHeight
        ) <= scrollThreshold
      ) {
        if (
          !therapistList?.last &&
          !isLoadingTherapistList &&
          therapistListState.length < therapistList?.totalElements
        ) {
          setTherapistTaskMainLoader(false);
          setTherapistListPageNo(therapistListPageNo + 1);
        }
      }
    },
    [isLoadingTherapistList, therapistListPageNo]
  );

  const openAnnouncementDialog = () => {
    dispatch(
      getAllAnnouncementsAction({
        selectedDate: moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      })
    );
    setOpenAnnounceDialog(true);
  };

  const handlecloseAnnounceDialog = () => {
    setOpenAnnounceDialog(false);
    dispatch(resetGetAllAnnouncementsAction());
  };

  return (
    <>
      <Seo title="Restore-Insights: Patient" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // py: 5,
        }}
      >
        <Container maxWidth={settings.stretch ? false : 'xl'}>
          <Stack spacing={2}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={'space-between'}
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={3}
              >
                <Stack gap="1rem">
                  <Typography variant="h4">Daily Therapist Scheduling</Typography>
                </Stack>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={4}
                >
                  <Tabs
                    indicatorColor="primary"
                    onChange={handleTabsChange}
                    scrollButtons="auto"
                    textColor="primary"
                    value={currentTab}
                    variant="scrollable"
                  >
                    {therapistTabs &&
                      therapistTabs?.map((tab: any) => (
                        <Tab
                          key={tab.key}
                          label={
                            <span>
                              <span>{tab.key}</span>
                              <Chip
                                sx={{ cursor: 'pointer', marginLeft: '10px', color: '#6C737F' }}
                                label={tab.count}
                                size="small"
                              />
                            </span>
                          }
                          value={tab.key}
                        />
                      ))}
                  </Tabs>
                </Stack>
                <Stack ref={calenderRef}>
                  <Button
                    sx={{
                      background: '#fff',
                      borderRadius: '12px',
                      border: '1px solid rgba(17, 25, 39, 0.16)',
                      color: '#384250',
                      '&:hover': {
                        border: '1px solid rgba(17, 25, 39, 0.16)',
                      },
                    }}
                    startIcon={
                      <SvgIcon>
                        <CalendarToday />
                      </SvgIcon>
                    }
                    variant="outlined"
                    onClick={handleClickCalender}
                  >
                    {formattedDate} {moment(jsDate).isSame(currentDate, 'day') && '(Today)'}
                  </Button>
                  {openCalender && (
                    <BasicDateCalendar
                      value={selectedDate}
                      handleChangeDate={handleChangeDate}
                    />
                  )}
                </Stack>
                {permissionData?.currentRoles?.includes('dor') && (
                  <Stack>
                    <IconButton
                      sx={{ height: '40px' }}
                      onClick={openAnnouncementDialog}
                    >
                      <AnnouncementIcon />
                    </IconButton>
                  </Stack>
                )}
              </Stack>
              <Stack
                flexDirection={'row'}
                alignItems={'center'}
              >
                <PayerColorLegend />
              </Stack>
            </Stack>

            <Stack
              direction="row"
              spacing={{
                xs: 2,
                lg: 3,
              }}
              sx={{ width: '100%' }}
            >
              <DragDropContext
                onDragEnd={handleDragDrop}
                onDragStart={(e) => {
                  setIsDragTerminated(false);
                  setDragged(true);
                  setDraggedId(e.draggableId);
                }}
              >
                <Stack
                  sx={{
                    // width: { lg: '65%', md: '50%', sm: '50%', xs: '50%' },
                    width: '32%',
                    display: 'flex',
                    maxWidth: '500px',
                    minWidth: '440px',
                    flexDirection: 'column',
                    gap: '1rem',
                  }}
                >
                  <Droppable droppableId="ROOT">
                    {(provided, snapshot) => (
                      <Stack
                        {...provided.droppableProps}
                        ref={(el) => {
                          provided.innerRef(el);
                        }}
                        id="patientTask"
                        sx={{
                          borderRadius: '15px',
                          background: snapshot.isDraggingOver ? '#e0f0ff' : '#F3F4F6 !important',
                          height: '82vh',
                          overflowX: 'scroll',
                          overflowY: 'scroll',
                          '::-webkit-scrollbar': {
                            width: '5px',
                          },
                          border: snapshot.isDraggingOver ? '1px solid #007bff' : 'none',
                        }}
                      >
                        <div
                          style={{
                            position: 'sticky',
                            height: '48px',
                            top: 0,
                            backgroundColor: '#F3F4F6 ',
                            zIndex: 1,
                          }}
                        >
                          <Box
                            sx={{
                              padding: '8px 0px 6px 16px',
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              gap: '8px',
                            }}
                          >
                            <Box
                              display="flex"
                              justifyContent="flex-start"
                              sx={{ marginRight: '10px' }}
                            >
                              <Typography
                                sx={{
                                  color: '#111927',
                                  fontFamily: 'Inter',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  lineHeight: '24px',
                                  letterSpacing: '0.5px',
                                }}
                              >
                                {'PATIENTS'}
                              </Typography>
                              <Chip
                                sx={{
                                  cursor: 'pointer',
                                  marginLeft: '10px',
                                  color: '#EEEEEE',
                                  '& .MuiChip-label': {
                                    whiteSpace: 'normal',
                                    fontSize: '13px',
                                    fontFamily: 'Inter',
                                    fontWeight: '500',
                                    lineHeight: '18px',
                                    letterSpacing: '0.16px',
                                    color: '#111927',
                                  },
                                }}
                                label={patientTotalElements || 0}
                                size="small"
                              />
                            </Box>

                            <Box sx={{ display: 'flex', height: '40px' }}>
                              <MultiSelect
                                label="Task type"
                                options={transformedTaskTypeArray(taskType) || []}
                                selectedValue={selectedTaskType}
                                resetVal={setTaskType}
                                onChange={(e: any) => {
                                  setTaskType(e);
                                  setPatientTaskShowMainLoader(true);
                                  setPatientTaskPageNo(0);
                                  setTaskSelectedId([]);
                                }}
                              />
                              <SkillsMultiSelect
                                label="Skill"
                                options={getTherapistSkillListResponse || []}
                                selectedValue={currentSkillSelected}
                                resetVal={setCurrentSkillSelected}
                                onChange={(e: any) => {
                                  setCurrentSkillSelected(e);
                                  setPatientTaskShowMainLoader(true);
                                  setPatientTaskPageNo(0);
                                  setTaskSelectedId([]);
                                }}
                              />
                            </Box>

                            <Box sx={{ display: 'flex' }}>
                              <Button
                                variant="text"
                                onClick={handleOpenAddTaskForm}
                                sx={{
                                  fontFamily: 'Inter',
                                  fontWeight: '600',
                                  fontSize: '14px',
                                  lineHeight: '22px ',
                                  letterSpacing: '0.2px ',
                                  color: '#111927',
                                }}
                                disabled={
                                  !permissionData?.currentPermissions?.includes(ADD_DAILY_TASK)
                                }
                              >
                                + Add Task
                              </Button>
                            </Box>
                          </Box>
                        </div>
                        <div
                          style={{
                            display:
                              isLoadingTherapistTask && showPatientTaskMainLoader ? 'flex' : 'none',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '50vh',
                          }}
                        >
                          <img
                            src={LoaderIcon}
                            alt="loader.."
                          />
                        </div>
                        {taskListState?.length == 0 ? (
                          <Box
                            sx={{
                              display:
                                isLoadingTherapistTask && showPatientTaskMainLoader
                                  ? 'none'
                                  : 'inherit',
                            }}
                            margin={'10px'}
                          >
                            All the patients have been assigned. Great work!
                          </Box>
                        ) : (
                          <InfiniteScroll
                            style={{
                              height: '100%',
                              display:
                                isLoadingTherapistTask && showPatientTaskMainLoader
                                  ? 'none'
                                  : 'inherit',
                              padding: '10px',
                            }}
                            dataLength={taskListState ? taskListState.length : 0}
                            next={() => {
                              setPatientTaskShowMainLoader(false);
                              setPatientTaskPageNo((prev) => prev + 1);
                            }}
                            scrollThreshold={'99%'}
                            hasMore={!isLastPatientList}
                            loader={
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: '100%',
                                }}
                              >
                                <img
                                  src={LoaderIcon}
                                  alt="loader.."
                                />
                              </div>
                            }
                            scrollableTarget={'patientTask'}
                          >
                            {taskListState?.map((patient: any, index: number) => {
                              return (
                                <Draggable
                                  draggableId={patient.uuid}
                                  key={patient?.uuid}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <Box
                                      {...provided.dragHandleProps}
                                      {...provided.draggableProps}
                                      ref={provided.innerRef}
                                    >
                                      <Table>
                                        <TableBody
                                          sx={{
                                            display: {
                                              md: 'flex',
                                              lg: 'flex',
                                              sm: 'flex',
                                              xs: 'flex',
                                            },
                                            position: 'relative',
                                            width: dragged
                                              ? 'initial'
                                              : matches
                                              ? '100%'
                                              : 'initial',
                                          }}
                                        >
                                          <TableRow
                                            sx={{
                                              borderRadius: '12px',
                                              display:
                                                dragged &&
                                                taskSelectedId.includes(patient.uuid) &&
                                                taskSelectedId.includes(draggedId) &&
                                                draggedId !== patient.uuid
                                                  ? 'none'
                                                  : 'flex',
                                              width: '100%',
                                              height: { lg: 'auto', md: 'auto', sm: 'auto' },
                                              margin: '6px 0px',
                                              padding: '.6rem 0',
                                              alignItems: 'flex-start',
                                              justifyContent: 'space-between',
                                              background: snapshot.isDragging ? '#EBEEFE' : '#FFF',
                                              boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.08)',
                                            }}
                                          >
                                            <td>
                                              <Stack
                                                className="store-container"
                                                direction="row"
                                                textAlign={'center'}
                                                sx={{
                                                  width: '100%',
                                                  borderRadius: '12px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  pointerEvents:
                                                    !updateDailyTasks || !readDailyTasks
                                                      ? 'none'
                                                      : 'inherit',
                                                }}
                                              >
                                                <TherapistTaskList
                                                  handleToRescheduleTask={handleToRescheduleTask}
                                                  setOpenTaskDeleteModal={setOpenTaskDeleteModal}
                                                  setCurrentPatientTask={setCurrentPatientTask}
                                                  patient={patient}
                                                  setTaskSelectedId={setTaskSelectedId}
                                                  taskSelectedId={taskSelectedId}
                                                  setOpenEditTimeDialog={setOpenEditTimeDialog}
                                                  handleOpenTaskNote={handleOpenTaskNote}
                                                  setIsEditNote={setIsEditNote}
                                                  setTherapyInfo={setTherapyInfo}
                                                />
                                                {dragged &&
                                                  taskSelectedId.includes(patient.uuid) &&
                                                  taskSelectedId.length > 1 && (
                                                    <Box
                                                      sx={{
                                                        background: 'red',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        padding: '2px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        color: 'white',
                                                        position: 'absolute',
                                                        right: '-2px',
                                                        top: '6px',
                                                      }}
                                                    >
                                                      {taskSelectedId.length}
                                                    </Box>
                                                  )}
                                              </Stack>
                                            </td>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </Box>
                                  )}
                                </Draggable>
                              );
                            })}
                          </InfiniteScroll>
                        )}

                        {provided.placeholder}
                      </Stack>
                    )}
                  </Droppable>
                </Stack>

                <Stack
                  sx={{
                    width: '68%',
                    display: 'flex',
                    minWidth: '400px',
                    flexDirection: 'column',
                    gap: '1rem',
                  }}
                >
                  <Stack
                    id="therapistId"
                    sx={{
                      borderRadius: '15px',
                      background: '#F3F4F6 !important',
                      height: '82vh',
                    }}
                  >
                    <div
                      style={{
                        position: 'sticky',
                        // minHeight: '48px',
                        height: 'auto',
                        top: 0,
                        backgroundColor: '#F3F4F6 ',
                        zIndex: 2,
                        borderRadius: '15px 15px 0px 15px',
                      }}
                    >
                      <Box
                        sx={{
                          padding: '8px 16px 0px 16px',
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          flexWrap: 'wrap',
                          // gap: '16px',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            height: '40px',
                            gap: '8px',
                            width: lgdown ? '100%' : '50%',
                          }}
                        >
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                          >
                            <Typography
                              sx={{
                                color: '#111927 !important',
                                fontFamily: 'Inter !important',
                                fontSize: '12px !important',
                                fontStyle: 'normal !important',
                                fontWeight: '600 !important',
                                lineHeight: '24px !important',
                                letterSpacing: '0.5px !important',
                              }}
                            >
                              {'THERAPISTS'}
                            </Typography>
                            <Chip
                              sx={{
                                cursor: 'pointer',
                                marginLeft: '10px',
                                color: '#EEEEEE',
                                '& .MuiChip-label': {
                                  whiteSpace: 'normal',
                                  fontSize: '13px ',
                                  fontFamily: 'Inter ',
                                  fontWeight: '500',
                                  lineHeight: '18px ',
                                  letterSpacing: '0.16px ',
                                  color: '#111927',
                                },
                              }}
                              label={therapistList?.totalElements || 0}
                              size="small"
                            />
                          </Box>
                          <Box>
                            <MultiSelectPatientList
                              label="Therapist"
                              options={
                                patientDisciplineList?.map((list: any) => {
                                  return {
                                    label: list[1],
                                    id: list[0],
                                  };
                                }) || []
                              }
                              selectedValue={filterTherapistList}
                              setTherapistListPageNo={setTherapistListPageNo}
                              appliedvalues={filterTherapistList?.length}
                              currentTab={currentTab}
                              onChange={(list: any) => {
                                setIsMaintainFilterAvailable(false);
                                setTherapistListPageNo(0);
                                dispatch(
                                  maintainTherapistFilterAction(list, currentTab, providerId)
                                );
                                // setFilterTherapistList(list);
                              }}
                            />
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: '40px',
                            justifyContent: lgdown ? 'none' : 'space-between',
                            width: lgdown ? '100%' : '50%',
                            gap: '20px',
                          }}
                        >
                          <Box>
                            <Switcher
                              onChange={(option: any) => {
                                setSwitchState(option);
                              }}
                              option1="Productivity Goal"
                              option2="PTIF"
                            />
                          </Box>
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                            sx={{
                              height: '30px',
                              width: '157px',
                              marginRight: '8px',
                            }}
                          >
                            <Button
                              onClick={() =>
                                dispatch(
                                  autoMatchingTherapistAction({
                                    providerId,
                                    discipline: currentTab ? currentTab : '',
                                    currentDate: selectedDate
                                      ? moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
                                      : '',
                                  })
                                )
                              }
                              disabled={
                                !((therapistList as any)?.totalElements > 0 && isAutoMatchDisable)
                              }
                              sx={{
                                fontFamily: 'Inter',
                                fontSize: '13px',
                                fontWeight: '600',
                                lineHeight: '18px',
                                letterSpacing: '0.2px',
                                borderRadius: '26px',
                                border: !(
                                  (therapistList as any)?.totalElements > 0 && isAutoMatchDisable
                                )
                                  ? '1px solid #38425080'
                                  : '1px solid #6364F1',
                                padding: '4px 6px 4px 10px',
                                textWrap: 'nowrap',
                              }}
                            >
                              Assign automatically
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                    </div>
                    <div
                      style={{
                        display:
                          (isLoadingTherapistList && showTherapistTaskMainLoader) ||
                          getAllMaintainedTherapists?.loading
                            ? 'flex'
                            : 'none',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '50vh',
                      }}
                    >
                      <img
                        src={LoaderIcon}
                        alt="my loader.."
                      />
                    </div>
                    {therapistListState?.length == 0 ? (
                      <Box
                        style={{
                          display:
                            (isLoadingTherapistList && showTherapistTaskMainLoader) ||
                            getAllMaintainedTherapists?.loading
                              ? 'none'
                              : 'inherit',
                        }}
                        margin={'10px'}
                      >
                        No therapist available
                      </Box>
                    ) : (
                      <>
                        <Grid
                          container
                          spacing={1.4}
                          sx={{
                            display:
                              isLoadingTherapistList && showTherapistTaskMainLoader
                                ? 'none'
                                : 'inherit',
                            height: 'auto',
                            p: 2,
                            maxHeight: '99%',
                            overflowY: 'scroll',
                            // scrollbarWidth: 'thin',
                          }}
                          onScroll={handleScroll}
                        >
                          {therapistListState &&
                            therapistListState.length > 0 &&
                            therapistListState?.map((therapist: any, index: number) => {
                              return (
                                <React.Fragment key={therapist?.uuid}>
                                  <Droppable
                                    key={therapist?.uuid}
                                    droppableId={therapist?.uuid}
                                  >
                                    {(provided) => (
                                      <Grid
                                        item
                                        {...provided.droppableProps}
                                        ref={(el) => {
                                          provided.innerRef(el);
                                        }}
                                        key={therapist?.uuid}
                                        flex={1}
                                        sx={{
                                          borderRadius: '12px',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          minWidth: '380px',
                                          alignItems: 'start',
                                        }}
                                      >
                                        <TherapistInfo
                                          therapist={therapist}
                                          setIsStatsRefresh={setIsStatsRefresh}
                                          isStatsRefresh={isStatsRefresh}
                                          DeleteTherapistPatient={DeleteTherapistPatient}
                                          providerId={
                                            typeof providerId === 'string' ? providerId : ''
                                          }
                                          openEditTimeDialog={noOfTherapistEditDialogOpen}
                                          setOpenEditTimeDialog={setNoOfTherapistEditDialogOpen}
                                          index={index}
                                          date={selectedDate}
                                          updateDailyTasks={updateDailyTasks}
                                          readDailyTasks={readDailyTasks}
                                          switchState={switchState}
                                          handleOpenTaskNote={handleOpenTaskNote}
                                          setIsEditNote={setIsEditNote}
                                          setCurrentPatientTask={setCurrentPatientTask}
                                        />
                                        {provided.placeholder}
                                      </Grid>
                                    )}
                                  </Droppable>
                                </React.Fragment>
                              );
                            })}
                        </Grid>
                        {isLoadingTherapistList && !showTherapistTaskMainLoader && (
                          <Box
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '100%',
                              top: '500px',
                              position: 'sticky',
                            }}
                          >
                            <img
                              src={LoaderIcon}
                              alt="loader.."
                            />
                          </Box>
                        )}
                      </>
                    )}
                  </Stack>
                </Stack>
              </DragDropContext>
            </Stack>
          </Stack>
        </Container>
      </Box>

      <BootstrapDialog
        onClose={handleCloseAddTaskForm}
        aria-labelledby="customized-dialog-title"
        open={openAddTaskForm}
      >
        <AddTaskForm
          date={selectedDate}
          currentTab={currentTab}
          selectedTaskType={selectedTaskType}
          handleCloseAddTaskForm={handleCloseAddTaskForm}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloseInfo}
        aria-labelledby="customized-dialog-title"
        open={openModal}
      >
        <InfoModal
          close={handleCloseInfo}
          message={
            infoTitle === 'Reassign Individual Tasks Only'
              ? 'Group and concurrent tasks cannot be reassigned directly between therapists. Would you like to proceed with reassigning individual tasks ?'
              : infoTitle === 'Reassigning Group & Concurrent Tasks'
              ? 'Group and concurrent therapy assignments cannot be reassigned directly. To update the assignment, please cancel the current one and reassign it to the appropriate therapist.'
              : 'Open therapy planning screen ?'
          }
          title={infoTitle}
          gotIt={infoTitle === 'Reassigning Group & Concurrent Tasks'}
          button={{
            saveLabel: 'Confirm',
            closeLabel: 'Cancel',
          }}
          displayTime={false}
          handleSaveBtn={handleSaveBtn}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={openDialog}
      >
        <InfoModal
          close={handleCloseDialog}
          message={
            infoTitle === 'Unassign Individual Tasks Only'
              ? 'Group and concurrent tasks cannot be unassigned directly. Would you like to proceed with unassigning individual tasks ?'
              : 'Group and concurrent therapy assignments cannot be unassigned directly.'
          }
          title={infoTitle}
          gotIt={infoTitle === 'Unassigning Group & Concurrent Tasks'}
          button={{
            saveLabel: 'Confirm',
            closeLabel: 'Cancel',
          }}
          displayTime={false}
          handleSaveBtn={handleUnassignConfirm}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloseDeleteModal}
        aria-labelledby="customized-dialog-title"
        open={deleteModalInfo.open || false}
      >
        <DeletePopupModal
          close={handleCloseDeleteModal}
          message={deleteModalInfo.message}
          button={{ saveLabel: deleteModalInfo.saveLabel, closeLabel: deleteModalInfo.closeLabel }}
          title={deleteModalInfo.title}
          handleSaveBtn={handleDeleteBtn}
        />
      </BootstrapDialog>

      <Modal open={sucessFullRequest}>
        <SucessModal
          close={closeSuccessModal}
          title={successModalTitle.title}
          message={successModalTitle.message}
        />
      </Modal>

      <BootstrapDialog
        onClose={() => setReSchedulingTask(false)}
        aria-labelledby="customized-dialog-title"
        open={reSchedulingTask}
      >
        <RescheduleTaskModal
          reSchedulingTaskDate={reSchedulingTaskDate}
          handleSelectDate={handleSelectDate}
          setReSchedulingTask={setReSchedulingTask}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleEditTimeDialog}
        aria-labelledby="customized-dialog-title"
        open={openEditTimeDialog}
      >
        <EditTaskTime
          providerId={typeof providerId === 'string' ? providerId : ''}
          handleEditTimeDialog={handleEditTimeDialog}
          therapyInfo={therapyInfo}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloseTaskNote}
        aria-labelledby="customized-dialog-title"
        open={isTaskNote}
      >
        <ScheduleTaskNote
          currentPatientTask={currentPatientTask}
          handleCloseTaskNote={handleCloseTaskNote}
          isEditNote={isEditNote}
          handleOpenDeleteTaskNote={handleOpenDeleteTaskNote}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={() => {
          setOpenGroupDialog(false);
          setCloseGroupDialog(true);
          setTaskSelectedId([]);
          setTherapistIdToDrop('');
          handleEditTime();
        }}
        aria-labelledby="customized-dialog-title"
        open={openGroupDialog}
      >
        <GroupTherapistTask
          assignGroupData={assignGroupData}
          setCloseGroupDialog={setCloseGroupDialog}
          setOpenGroupDialog={setOpenGroupDialog}
          providerId={typeof providerId === 'string' ? providerId : ''}
          selectedDate={selectedDate}
          therapistIdToDrop={therapistIdToDrop}
          setTaskSelectedId={setTaskSelectedId}
          meta={meta}
          isV2={true}
          assignTaskPage={assignTaskPage}
          currentTab={currentTab}
        />
      </BootstrapDialog>

      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '600px' } }}
        onClose={() => setOpenAnnounceDialog(false)}
        aria-labelledby="customized-dialog-title"
        fullWidth
        open={openAnnounceDialog}
      >
        <AnnouncementDialog
          date={jsDate}
          handleCloseDialog={handlecloseAnnounceDialog}
          handleOpenDeleteAnnounceModal={handleOpenDeleteAnnounceModal}
        />
      </BootstrapDialog>

      {popUpMessage.message && (
        <SimpleSnackbar
          message={popUpMessage.message}
          isError={popUpMessage.type === 'ERROR'}
          isWarning={popUpMessage.type === 'WARNING'}
        />
      )}

      {showLoader && <Loader />}
    </>
  );
};

export default TherapistSchedule;
